import React, {FC, useCallback, useEffect, useState} from 'react' 
import {useFormik} from 'formik'
import {initialVehicleOwner, IVehicleOwnerModel, validationVehicleOwner} from './VehicleOwnerModel'
import {createvehicleOwner, loadvehicleOwner, deletevehicleOwner, updatevehicleOwner} from './Api'
import clsx from 'clsx'
import {ConfirmModal} from '../../../../shared/components/ConfirmModal'
import {showErrorToast, showSuccessToast} from '../../../../shared/components/ToastUtils'
import {ToastContainer} from 'react-toastify'
 
const VehicleOwnerPage: FC = () => {
  const [loading, setLoading] = useState(false)
  const [Vehicleowners, setVehicleOwners] = useState<IVehicleOwnerModel[]>([])
  const [selectedId, setSelectedId] = useState<string | null>(null) 
  const [showModal, setShowModal] = useState(false)
  const [controlSaveButton, setControlSaveButton] = useState(true)

  const getVehicleowners = useCallback(async () => {
    try {
      const res = await loadvehicleOwner(0)
      setVehicleOwners(res.data.payload.content)
    } catch (err) {
      console.error(err)
    }
  }, [])

  useEffect(() => {
    getVehicleowners()
  }, [getVehicleowners])

  const formik = useFormik<IVehicleOwnerModel>({
    initialValues: initialVehicleOwner,
    validationSchema: validationVehicleOwner,
    enableReinitialize: true,
    onSubmit: async (values, {resetForm}) => {
      try {
        if (selectedId !== null) {
          await updatevehicleOwner(selectedId.toString(), values.name)
        } else {
          await createvehicleOwner(values.name)
        }
        resetForm()
        setSelectedId(null)
        getVehicleowners()
      } catch (err) {
        console.error(err)
        showErrorToast('Araç sahibi grubu kayıt edilirken bir hata oluştu')
      } finally {
        setLoading(false) 
        setSelectedId(null) 
        setControlSaveButton(true);
      }
    },
  })

  const handleEdit = (group: IVehicleOwnerModel) => {
    formik.setValues(group)
    setSelectedId(group.id)
    setControlSaveButton(false);
  }

  const handleDeleteClick = (owner: IVehicleOwnerModel) => {
    setSelectedId(owner.id)
    setShowModal(true)
  }

  const handleDelete = async () => {
    if (selectedId) {
      setLoading(true)
      try {
        await deletevehicleOwner(selectedId)
        showSuccessToast('Araç sahibi başarıyla silindi')
        await getVehicleowners()
      } catch (err) {
        console.error(err)
        showErrorToast('Araç sahibi silinirken bir hata oluştu')
      } finally {
        setLoading(false)
        setShowModal(false)
        setSelectedId(null) 
      }
    }
  }

  return (
    <>  
      <div className='card p-0 mb-5'>
        <div className='d-flex justify-content-between align-items-center border-bottom p-5'>
          <div className='d-flex align-items-center gap-3'>
            <i className='bi bi-layers fs-2'></i>
            <h5 className='mb-0 fw-semibold'>Araç Sahip Grubu Tanımlaması</h5>
          </div> 
        </div>
        <form
          onSubmit={formik.handleSubmit}
          id='ownerGroupForm'
          className='px-5 py-10 d-flex flex-column gap-5'
        >
          <div className='d-flex align-items-center'>
            <label className='fw-semibold me-4 mb-0'>
              <strong>Araç Sahip Grubu</strong>
            </label>
            <div style={{maxWidth: '300px'}}>
              <input
                type='text'
                placeholder='Araç Sahibi Grubu'
                className={clsx('form-control h-35px w-300px', {
                  'is-invalid': formik.touched.name && formik.errors.name,
                })}
                {...formik.getFieldProps('name')}
              />
              {formik.touched.name && formik.errors.name && (
                <div className='text-danger mt-1'>{formik.errors.name}</div>
              )}
            </div>
          </div>
          <div className='d-flex justify-content-start'>
            <button type='submit' className='btn btn-primary btn-sm'>
              {controlSaveButton ? 'Kaydet' : 'Güncelle'}
            </button>
          </div>
        </form>
      </div>

      <div className='card p-0'>
        <div className='bg-light px-5 py-0'>
          <strong className='fw-semibold'>Araç Sahibi Listesi</strong>
        </div>
        <div className='px-8 py-8'>
          <ul className='list-unstyled mb-10'>
            {Vehicleowners.map((group) => (
              <li key={group.id} className='d-flex justify-content-between align-items-center py-2'>
                <span className='text-primary'>{group.name}</span>
                <div>
                  <button
                    className='btn btn-sm btn-light-primary me-2'
                    onClick={() => handleEdit(group)}
                  >
                    Düzenle
                  </button>
                  <button className='btn btn-sm btn-light-danger' onClick={() => handleDeleteClick(group)}>
                    Sil
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <ConfirmModal
        show={showModal}
        header='Silme Onayı'
        text='Bu Araç Sahibi Grubunu silmek istediğinize emin misiniz?'
        handleClose={() => {
          setShowModal(false)
          setSelectedId(null)
        }}
        applyOnClick={handleDelete}
      />
      <ToastContainer
        position='top-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  )
}

export {VehicleOwnerPage}
